import { FINISH_STARTUP, WS_CONNECTED, WS_DISCONNECTED } from './action-types';

const initialState = {
  startupFinished: false,
  wsConnected: false,
};

export function globalReducer(state = initialState, { type }) {
  switch (type) {
    case WS_CONNECTED:
      return {
        ...state,
        wsConnected: true,
      };
    case WS_DISCONNECTED:
      return {
        ...state,
        wsConnected: false,
      };
    case FINISH_STARTUP:
      return {
        ...state,
        startupFinished: true,
      };
    default:
      return state;
  }
}
